import { render, staticRenderFns } from "./Engagement.vue?vue&type=template&id=00201172&scoped=true&"
import script from "./Engagement.vue?vue&type=script&lang=js&"
export * from "./Engagement.vue?vue&type=script&lang=js&"
import style0 from "./Engagement.vue?vue&type=style&index=0&id=00201172&lang=scss&scoped=true&"
import style1 from "./Engagement.vue?vue&type=style&index=1&id=00201172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00201172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00201172')) {
      api.createRecord('00201172', component.options)
    } else {
      api.reload('00201172', component.options)
    }
    module.hot.accept("./Engagement.vue?vue&type=template&id=00201172&scoped=true&", function () {
      api.rerender('00201172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/Engagement.vue"
export default component.exports